// documentUtils.js

import { toast } from "react-toastify";
import { postMultiPartFormData } from "../api";

// Utility function to handle document upload and extract the URL
export const uploadDocumentAndGetUrl = async (formData, token) => {
  const url = "api/document/upload";
  try {
    const res = await postMultiPartFormData(url, formData, token);
    return res?.data?.url ?? null; // Safely return the URL or null if not present
  } catch (error) {
    console.error("Error uploading document:", error);
    return null;
  }
};
export const uploadCRMDocumentAndGetUrl = async (formData, token) => {
  const url = "api/crm/document/upload";
  try {
    const res = await postMultiPartFormData(url, formData, token);
    return res?.data?.url ?? null; // Safely return the URL or null if not present
  } catch (error) {
    console.error("Error uploading document:", error);
    return null;
  }
};
export const handleDocumentUploads = async (documents, token, showToast) => {
  const newDocuments = { ...documents };

  // Maximum file size in bytes (10 MB)
  const MAX_FILE_SIZE = 10 * 1024 * 1024;

  // Iterate over all keys in the documents object
  for (const key of Object.keys(newDocuments)) {
    if (newDocuments[key] && newDocuments[key]?.name) {
      try {
        // Check file size
        if (newDocuments[key].size > MAX_FILE_SIZE) {
          toast.error(`File size for ${newDocuments[key]?.name} exceeds 10 MB. Please upload a smaller file.`);
          return false;
        }

        // Create a new FormData object for each document
        const formData = new FormData();
        // Append the document Blob/File as a file to the FormData
        formData.append("file", newDocuments[key], newDocuments[key].name);
        // Upload the document and get the URL
        const url = await uploadDocumentAndGetUrl(formData, token);

        // Assign the uploaded URL back to the document field
        if (url) {
          newDocuments[key] = { url, name: newDocuments[key]?.name };
        } else {
          toast.error(`Failed to upload document for ${newDocuments[key]?.name}`);
          console.warn(`Failed to upload document for ${newDocuments[key]?.name}`);
          return false;
        }
      } catch (error) {
        toast.error(`Error while uploading document for ${newDocuments[key]?.name}`);
        console.error(`Error uploading document for ${key}:`, error);
        return false;
      }
    }
  }

  // After all uploads are complete, return the updated documents object
  return newDocuments;
};